<template>
  <div
    id="click-me"
    v-scroll-to="{el: '#about', offset: -50}"
  >
    <p>Dowiedz się więcej</p>
    <div id="arrow"></div>
  </div>
</template>

<script>
export default {
  name: 'ClickMe',
  created() {
    setTimeout(() => {
      try {
        const clickMe = document.querySelector('#click-me');
        clickMe.classList.add('pulse');
        clickMe.addEventListener('click', () => { clickMe.classList.remove('pulse'); });
        document.addEventListener('scroll', () => { clickMe.classList.remove('pulse'); });
      } catch (err) {
        console.log('Niewielki błąd strony');
      }
    }, 1);
  },
};
</script>

<style scoped lang="scss">
  #click-me {
    $height: 100px;
    $margin: 75px;

    position: absolute;
    top: calc(100vh - #{$height} - #{$margin});
    width: 100%; height: $height;

    display: flex; flex-direction: column;
    justify-content: center; align-items: center;

    font-family: 'Quicksand', sans-serif;
    color: white;

    cursor: pointer;
  }

  #arrow {
    position: absolute;
    left: calc(50% - 20px);
    bottom: 10px;
    width: 40px;
    height: 5px;

    &::before, &::after {
      position: absolute;
      content: ''; display: block;
      width: 40px; height: 5px;
      background-color: white;
    }

    $position: 12.5px;

    &::before {
      transform: rotate(45deg);
      left: -$position;
    }

    &::after {
      transform: rotate(-45deg);
      left: $position;
    }
  }

  @keyframes pulse {
    from { transform: scale3d(1, 1, 1); }
    50% { transform: scale3d(1.05, 1.05, 1.05); }
    to { transform: scale3d(1, 1, 1); }
  }

  .pulse {
    animation: pulse 2s infinite;
  }
</style>
